(function () {
  var STORAGE_KEY = 'lmpFavorites';
  var SHARED_SESSION_KEY = 'lmpSharedFavoritesLast';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getFavorites() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function setFavorites(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items || [])); }
    catch (e) {}
  }

  function setSharedSession(handles) {
    try { sessionStorage.setItem(SHARED_SESSION_KEY, JSON.stringify(handles || [])); }
    catch (e) {}
  }

  function getSharedSession() {
    try { return JSON.parse(sessionStorage.getItem(SHARED_SESSION_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[char];
    });
  }

  function formatMoney(cents) {
    var value = Number(cents || 0);
    if (!value) return '';
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(value / 100);
    } catch (e) {
      return (value / 100).toFixed(2).replace('.', ',') + ' EUR';
    }
  }

  function toast(title, message, linkText, linkHref) {
    var node = document.querySelector('[data-lmp-fav-toast]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'lmp-fav-toast';
      node.setAttribute('data-lmp-fav-toast', '');
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      document.body.appendChild(node);
    }
    node.innerHTML = '<strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(message) + '</span>' + (linkText && linkHref ? '<a class="lmp-fav-toast__link" href="' + escapeHtml(linkHref) + '">' + escapeHtml(linkText) + '</a>' : '');
    node.classList.add('is-visible');
    clearTimeout(toast.timer);
    toast.timer = setTimeout(function () { node.classList.remove('is-visible'); }, 4300);
  }

  function normalizeHandle(item) {
    if (!item) return '';
    var raw = typeof item === 'string' ? item : (item.handle || item.product_handle || '');
    raw = String(raw).trim();
    raw = raw.replace(/^https?:\/\/[^/]+\/products\//i, '');
    raw = raw.replace(/^\/products\//i, '');
    raw = raw.split(/[?#]/)[0];
    try { raw = decodeURIComponent(raw); } catch (e) {}
    return raw.toLowerCase().replace(/[^a-z0-9\-_]/g, '').slice(0, 180);
  }

  function uniqueHandles(handles) {
    var seen = {};
    var list = [];
    (handles || []).forEach(function (handle) {
      handle = normalizeHandle(handle);
      if (handle && !seen[handle]) {
        seen[handle] = true;
        list.push(handle);
      }
    });
    return list;
  }

  function base64UrlEncode(value) {
    try { return btoa(unescape(encodeURIComponent(value))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, ''); }
    catch (e) { return ''; }
  }

  function base64UrlDecode(value) {
    if (!value) return '';
    try {
      value = String(value).replace(/-/g, '+').replace(/_/g, '/');
      while (value.length % 4) value += '=';
      return decodeURIComponent(escape(atob(value)));
    } catch (e) { return ''; }
  }

  function getSharedHandlesFromUrl() {
    var params = new URLSearchParams(window.location.search || '');
    var fromNew = [];
    var packed = params.get('f') || params.get('fav') || params.get('wl') || '';
    if (packed) {
      var decoded = base64UrlDecode(packed);
      if (decoded) {
        try {
          var parsed = JSON.parse(decoded);
          if (Array.isArray(parsed)) fromNew = parsed;
          else if (parsed && Array.isArray(parsed.handles)) fromNew = parsed.handles;
        } catch (e) { fromNew = decoded.split(','); }
      }
    }
    var legacy = [];
    var legacyValue = params.get('favoriten') || params.get('wishlist') || params.get('handles') || '';
    if (legacyValue) legacy = legacyValue.split(',');
    return uniqueHandles(fromNew.concat(legacy));
  }

  function favoritesToHandles() { return uniqueHandles(getFavorites().map(normalizeHandle)); }

  function mergeHandlesIntoLocal(handles) {
    handles = uniqueHandles(handles);
    if (!handles.length) return [];
    var existing = getFavorites();
    var map = {};
    existing.forEach(function (item) {
      var handle = normalizeHandle(item);
      if (handle) map[handle] = typeof item === 'string' ? { handle: handle } : item;
    });
    handles.forEach(function (handle) {
      if (!map[handle]) {
        map[handle] = { handle: handle, title: handle.replace(/-/g, ' '), url: '/products/' + encodeURIComponent(handle), addedAt: new Date().toISOString(), source: 'shared-link' };
      }
    });
    var next = Object.keys(map).map(function (key) { return map[key]; });
    setFavorites(next);
    return handles;
  }

  function buildShareUrl() {
    var handles = favoritesToHandles();
    var base = window.location.origin + '/pages/favoriten';
    if (!handles.length) return base;
    var payload = JSON.stringify({ handles: handles, source: 'lausitzer-marktplatz' });
    var encoded = base64UrlEncode(payload);
    if (encoded) return base + '?f=' + encoded;
    return base + '?favoriten=' + encodeURIComponent(handles.join(','));
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    document.execCommand('copy');
    document.body.removeChild(area);
    return Promise.resolve();
  }

  function productCard(product, isSharedView) {
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var url = product.url || ('/products/' + product.handle);
    var price = formatMoney(product.price);
    return '' +
      '<article class="lmp-favorites-card" data-lmp-fav-item data-handle="' + escapeHtml(product.handle) + '">' +
        '<a class="lmp-favorites-card__image" href="' + escapeHtml(url) + '">' +
          (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '<span>' + escapeHtml((product.title || '?').slice(0,1)) + '</span>') +
        '</a>' +
        '<div class="lmp-favorites-card__body">' +
          (isSharedView ? '<p class="lmp-favorites-card__kicker">Ausgewählt für Sie</p>' : '') +
          '<a class="lmp-favorites-card__title" href="' + escapeHtml(url) + '">' + escapeHtml(product.title || product.handle) + '</a>' +
          (price ? '<div class="lmp-favorites-card__price">' + price + '</div>' : '<div class="lmp-favorites-card__price lmp-favorites-card__price--empty">Preis im Produkt</div>') +
          '<div class="lmp-favorites-card__actions">' +
            '<a class="lmp-mini-btn lmp-mini-btn--dark" href="' + escapeHtml(url) + '">' + (isSharedView ? 'Warum dieses Produkt?' : 'Details ansehen') + '</a>' +
            '<button class="lmp-mini-btn" type="button" data-lmp-remove-fav="' + escapeHtml(product.handle) + '">' + (isSharedView ? 'Aus dieser Auswahl entfernen' : 'Entfernen') + '</button>' +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function loadProducts(handles) {
    handles = uniqueHandles(handles);
    return Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('missing'); return res.json(); })
        .then(function (product) { product.handle = product.handle || handle; product.url = product.url || ('/products/' + handle); return product; })
        .catch(function () { return { handle: handle, title: handle.replace(/-/g, ' '), url: '/products/' + handle, price: 0, featured_image: '' }; });
    }));
  }

  function updateHero(root, count, isSharedView) {
    var countNode = root.querySelector('[data-lmp-favorites-count]');
    var sourceNode = root.querySelector('[data-lmp-favorites-source]');
    var titleNode = root.querySelector('[data-lmp-favorites-title]');
    var leadNode = root.querySelector('[data-lmp-favorites-lead]');
    var badgeNode = root.querySelector('[data-lmp-favorites-badge]');
    var saveButton = root.querySelector('[data-lmp-save-shared-favorites]');
    var shareButton = root.querySelector('[data-lmp-share-favorites]');
    if (countNode) countNode.textContent = count;
    if (root) root.classList.toggle('is-shared-favorites', !!isSharedView);
    if (sourceNode) sourceNode.textContent = isSharedView ? 'Eine persönliche Auswahl für Sie' : 'Ihre persönliche Merkliste';
    if (titleNode) titleNode.textContent = isSharedView ? 'Jemand hat Lieblingsprodukte mit Ihnen geteilt' : 'Favoriten ansehen und teilen';
    if (leadNode) {
      leadNode.textContent = isSharedView
        ? 'Diese Auswahl wurde bewusst zusammengestellt und an Sie geschickt. Nehmen Sie sich in Ruhe einen Moment: Vielleicht steckt darin genau die Idee, das Geschenk oder die Lösung, die zu Ihnen passt.'
        : 'Sammeln Sie Produkte, die Sie später vergleichen, bestellen oder mit anderen teilen möchten. Aus einer Merkliste wird so schnell eine echte Empfehlung.';
    }
    if (badgeNode) {
      badgeNode.innerHTML = isSharedView
        ? '<strong>Für Sie ausgewählt</strong><span>Nicht irgendeine Liste. Eine Empfehlung von einem Menschen, der an Sie gedacht hat.</span>'
        : '<strong>Merken. Vergleichen. Teilen.</strong><span>Ihre Auswahl bleibt auf diesem Gerät gespeichert.</span>';
    }
    if (saveButton) saveButton.hidden = !isSharedView;
    if (shareButton) shareButton.textContent = isSharedView ? 'Diese Auswahl weiterempfehlen' : 'Merkliste teilen';
  }

  function renderFavoritesPage() {
    var root = document.querySelector('[data-lmp-favorites-page]');
    if (!root) return;
    var sharedHandles = getSharedHandlesFromUrl();
    var isSharedView = sharedHandles.length > 0;
    if (isSharedView) setSharedSession(sharedHandles);
    var handles = isSharedView ? sharedHandles : favoritesToHandles();
    if (!isSharedView && !handles.length) {
      var rememberedShared = getSharedSession();
      if (rememberedShared.length && window.location.search.indexOf('favoriten') > -1) { handles = rememberedShared; isSharedView = true; }
    }
    var list = root.querySelector('[data-lmp-favorites-list]');
    var empty = root.querySelector('[data-lmp-favorites-empty]');
    updateHero(root, handles.length, isSharedView);
    if (!handles.length) {
      if (list) list.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (list) list.innerHTML = '<div class="lmp-loading-line">Die persönliche Auswahl wird geladen ...</div>';
    loadProducts(handles).then(function (products) {
      if (list) list.innerHTML = products.map(function (product) { return productCard(product, isSharedView); }).join('');
      if (isSharedView) toast('Persönliche Auswahl geöffnet', products.length + ' Produkte wurden für Sie zusammengestellt.', 'Auswahl merken', '#lmp-save-shared');
    });
  }

  function saveSharedFavoritesFromUrl() {
    var handles = getSharedHandlesFromUrl();
    if (!handles.length) handles = getSharedSession();
    handles = mergeHandlesIntoLocal(handles);
    document.dispatchEvent(new CustomEvent('lmp:favorites:changed'));
    renderFavoritesPage();
    toast('Auswahl gespeichert', handles.length + ' Produkte wurden in Ihre eigene Merkliste übernommen.');
  }

  function bindShareButtons() {
    document.addEventListener('click', function (event) {
      var pageShare = event.target.closest('[data-lmp-share-favorites]');
      if (pageShare) {
        var url = buildShareUrl();
        if (navigator.share) {
          navigator.share({ title: 'Eine persönliche Produktauswahl vom Lausitzer Marktplatz', text: 'Ich habe diese Auswahl für dich zusammengestellt.', url: url })
            .then(function () { toast('Auswahl bereit zum Teilen', 'Der Link zu Ihrer persönlichen Empfehlung wurde vorbereitet.'); })
            .catch(function () { copyText(url).then(function () { toast('Link kopiert', 'Der Link zu Ihrer persönlichen Auswahl wurde kopiert.'); }); });
        } else { copyText(url).then(function () { toast('Link kopiert', 'Der Link zu Ihrer persönlichen Auswahl wurde kopiert.'); }); }
      }
      var saveShared = event.target.closest('[data-lmp-save-shared-favorites], #lmp-save-shared');
      if (saveShared) { event.preventDefault(); saveSharedFavoritesFromUrl(); }
      var productShare = event.target.closest('[data-lmp-share-product]');
      if (productShare) {
        var urlProduct = productShare.getAttribute('data-product-url') || window.location.href;
        var title = productShare.getAttribute('data-product-title') || document.title;
        if (urlProduct.indexOf('http') !== 0) urlProduct = window.location.origin + urlProduct;
        if (navigator.share) { navigator.share({ title: title, url: urlProduct }).catch(function () { copyText(urlProduct).then(function () { toast('Link kopiert', 'Der Produktlink wurde kopiert.'); }); }); }
        else { copyText(urlProduct).then(function () { toast('Link kopiert', 'Der Produktlink wurde kopiert.'); }); }
      }
      var pageShareCurrent = event.target.closest('[data-lmp-share-page]');
      if (pageShareCurrent) {
        var urlPage = window.location.href;
        if (navigator.share) { navigator.share({ title: document.title, url: urlPage }).catch(function () { copyText(urlPage).then(function () { toast('Link kopiert', 'Der Seitenlink wurde kopiert.'); }); }); }
        else { copyText(urlPage).then(function () { toast('Link kopiert', 'Der Seitenlink wurde kopiert.'); }); }
      }
      var remove = event.target.closest('[data-lmp-remove-fav]');
      if (remove) {
        var handleRemove = normalizeHandle(remove.getAttribute('data-lmp-remove-fav'));
        var sharedHandles = getSharedHandlesFromUrl();
        if (sharedHandles.length) {
          var nextShared = sharedHandles.filter(function (handle) { return handle !== handleRemove; });
          setSharedSession(nextShared);
          var payload = base64UrlEncode(JSON.stringify({ handles: nextShared, source: 'lausitzer-marktplatz' }));
          var nextUrl = window.location.origin + window.location.pathname + (nextShared.length && payload ? '?f=' + payload : '');
          window.history.replaceState({}, '', nextUrl);
          renderFavoritesPage();
          toast('Auswahl angepasst', 'Das Produkt wurde nur aus dieser Ansicht entfernt.');
        } else {
          var next = getFavorites().filter(function (item) { return normalizeHandle(item) !== handleRemove; });
          setFavorites(next);
          renderFavoritesPage();
          document.dispatchEvent(new CustomEvent('lmp:favorites:changed'));
          toast('Favorit entfernt', 'Das Produkt wurde aus Ihrer Merkliste entfernt.');
        }
      }
      var clear = event.target.closest('[data-lmp-clear-favorites]');
      if (clear) {
        if (getSharedHandlesFromUrl().length) { window.history.replaceState({}, '', window.location.origin + window.location.pathname); setSharedSession([]); }
        else { setFavorites([]); document.dispatchEvent(new CustomEvent('lmp:favorites:changed')); }
        renderFavoritesPage();
        toast('Ansicht geleert', 'Die aktuelle Favoritenansicht wurde geleert.');
      }
    });
  }

  ready(function () { renderFavoritesPage(); bindShareButtons(); });
})();
